import { createAction } from '@ngrx/store';
import { AppActions } from '../app-actions.enum';

export const loadStateRequest = createAction(AppActions.LOAD_STATE_REQUEST);
